import { Theme } from "@app/theme";
import { useTheme } from "@shopify/restyle";
import Svg, { Line } from "react-native-svg";

const DashedLine = () => {
    const {colors} = useTheme<Theme>()
    return (
        <Svg height="1" width="100%"> 
            <Line x1="0" y1="1" x2={'100%'} y2="1" stroke={colors['border-primary']}
            strokeWidth="2" strokeDasharray="8,8" 
            />
        </Svg>
    )
}

export default DashedLine;